import Config from '../config'


var URLMapper = {
    /**
     * in case the application is currently running on a secure domain
     * remap given URL to also be on https://
     *
     * @param {string} aURL
     * @return {string}
     */
    mapToSecure: function( aURL ) {
        if ( isSecure( aURL )) {
            return aURL;
        }
        if ( isSecure( window.location.protocol )) {
            aURL = aURL.replace( "http", "https" );
        }
        // strip ports (80, 8080 and 443 will automatically be available on the server as appropriate)
        return aURL.replace( ":80", "" );
    },

    /**
     * XE-12076: some S3 URLs have a too large subdomain to allow AWS security certificate to work
     * we can however make this work by remapping the subdomain after the bucket location
     *
     * @public
     * @param {string} aURL
     * @return {string}
     */
    remapS3: function( aURL ) {
        if ( !isSecure( aURL ) && Config["photoUpload"]["remap"] === "true" ) {
            var regex = new RegExp(
                /** @type {string} */ ( Config["photoUpload"]["regex"])
            );
            var matches = aURL.match( regex );

            // if matches were found this implies we are dealing with an S3 bucket URL
            if ( matches && matches.length > 1 ) {
                var domain = matches[ 1 ];
                // remove domain from URL
                aURL = aURL.replace( domain, "" );
                // get the first slash after http(s)://
                var slashIndices = getIndicesFor( aURL, /\//gi );

                if ( slashIndices && slashIndices.length > 2 ) {

                    // move subdomain into highest domain suffix, e.g.:
                    // http://photos.photoconnector.s3-eu-west-1.amazonaws.com/
                    // becomes:
                    // https://s3-eu-west-1.amazonaws.com/photos.photoconnector

                    var slashIndex = slashIndices[ 2 ];
                    var prefix = aURL.substring( 0, slashIndex );
                    var suffix = aURL.substring( slashIndex );

                    // remove last character from domain (is a dot)
                    domain = domain.substring( 0, domain.length - 1 );

                    // format final URL
                    aURL = prefix + "/" + domain + suffix;
                }
                // map non secure URL to secure URL when necessary
                aURL = URLMapper.mapToSecure(
                    // also remove double slashes (e.g. legacy saved products
                    // have amazon.com// instead of amazon.com/
                    aURL.replace( "m//", "m/" )
                );
            }
        }
        return aURL;
    }
};

/* helper functions */

/**
 * checks whether given url or url fragment
 * is a secure domain (e.g. is https)
 *
 * @private
 * @param {string} url
 * @return {boolean}
 */
function isSecure( url ) {
    return url.indexOf( "https" ) > -1;
}

/**
* returns all indices at which given regex sequence occur
* in given string
*
* @public
* @param {string} string
* @param {RegExp} regex
* @return {Array.<number>}
*/
function getIndicesFor( string, regex ) {
    const indices = [];
    var result;
    while (( result = regex.exec( string ))) {
        indices.push( result.index );
    }
    return indices;
}

export default URLMapper
